import axios from 'axios'
import _ from 'lodash'

// state
const state = {

}

const getters = {

}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	SET_USER (state, user){
		state.user = user
		sessionStorage.setItem("USER", JSON.stringify(user.data));
	},

	SET_FORM_DATA (state, {formData}){
		state.formData = formData
	},

	SET_PAGE_REFRESH(state){
		sessionStorage.setItem("FORM-DATA", JSON.stringify(state.formData))
		sessionStorage.setItem("VENDOR-PAYMENT-DATA", JSON.stringify(state.vendorPayment))
		sessionStorage.setItem("USER", JSON.stringify(state.user))
	},

	SET_PAGE_DONE(state){
		if(sessionStorage.getItem("FORM-DATA") !== null && sessionStorage.getItem("FORM-DATA") !== '' && sessionStorage.getItem("FORM-DATA") !== 'undefined'){
			state.formData = JSON.parse(sessionStorage.getItem("FORM-DATA"))
		}
		if(sessionStorage.getItem("VENDOR-PAYMENT-DATA") !== null && sessionStorage.getItem("VENDOR-PAYMENT-DATA") !== '' && sessionStorage.getItem("VENDOR-PAYMENT-DATA") !== 'undefined'){
			state.vendorPayment = JSON.parse(sessionStorage.getItem("VENDOR-PAYMENT-DATA"))
		}

		if(sessionStorage.getItem("USER") !== null && sessionStorage.getItem("USER") !== '' && sessionStorage.getItem("USER") !== 'undefined'){
			state.user = JSON.parse(sessionStorage.getItem("USER"))
		}

		if(sessionStorage.getItem("REMARKS-DATA") !== null && sessionStorage.getItem("REMARKS-DATA") !== '' && sessionStorage.getItem("REMARKS-DATA") !== 'undefined'){
			state.remarksData = JSON.parse(sessionStorage.getItem("REMARKS-DATA"))
		}

		sessionStorage.removeItem("FORM-DATA")
		sessionStorage.removeItem("VENDOR-PAYMENT-DATA")
		sessionStorage.removeItem("USER")
		sessionStorage.removeItem("REMARKS-DATA")
	}
}

// actions
const actions = {
	pageRefresh ({commit}){
		commit('SET_PAGE_REFRESH')
	},

	pageDone ({commit, dispatch}){
		commit('SET_PAGE_DONE')
	},

	openPrintableRequest({commit, dispatch, rootState, state}, apptId){
		var jobType = rootState.requests.formData[0].job_type_id;

		sessionStorage.setItem("FORM-DATA", JSON.stringify(rootState.requests.formData));
		sessionStorage.setItem("VENDOR-PAYMENT-DATA", JSON.stringify(rootState.requests.vendorPayment));
		sessionStorage.setItem("REMARKS-DATA", JSON.stringify(rootState.requests.remarksData));
		sessionStorage.setItem("USER", JSON.stringify(rootState.auth.user));

        switch(jobType){
            // 1 - Interpretation
            case 1:
				var win = window.open('/print-interpretation', '_blank');
		        win.focus();
                break;
            // 2 - Translation
            case 2:
				var win = window.open('/print-translation', '_blank');
		        win.focus();
                break;
            // 3 - Telephonic
			// 4 - VRI
            case 3:
			case 4:
				var win = window.open('/print-telephonic', '_blank');
		        win.focus();
                break;
        }
	},

	// determine which type of client
	saveAsPDF({commit, dispatch, rootState, state}, apptId){
		var jobType = rootState.requests.formData[0].job_type_id;

        switch(jobType){
            // 1 - Interpretation
            case 1:
            	dispatch('saveAsInterpretationPDF');
                break;
            // 2 - Translation
            case 2:
            	dispatch('saveAsTranslationPDF');
                break;
            // 3 - Telephonic
            case 3:
            	dispatch('saveAsTelephonicPDF');
                break;
            // 4 - Telephonic
            case 4:
            	dispatch('saveAsTelephonicPDF');
                break;
        }
	},

	// Intereptation Export to PDF
	saveAsInterpretationPDF({commit, dispatch, rootState, state}, apptId){
		dispatch('global/getTimestamp', {}, {root: true});
		var formData = rootState.requests.formData;
		var vendorPayment = rootState.requests.vendorPayment;
		var user = rootState.auth.user;
		var clientRequestId = formData[0].id;
		var jobNo = formData[0].job_no;
		var html = "";
		var statusClass = sessionStorage.getItem("statusClass");
		var showNotes = sessionStorage.getItem("showNotes");
		// var remarks = JSON.parse(sessionStorage.getItem("REMARKS-DATA"));
		// var cancelNotes = remarks.remarks_notes;

		var showNotesClass = '';
		var status = formData[0].status;

		//Create the Client Request content
    	html += "<div class='print-request'>";
    		html += "<div class='columns'>";
    			html += "<div class='column is-12'>";
	                html += "<div class='columns'>";
	                    html += "<table class='heading'>";
	                     	html += "<tr>";
		                        html += "<td><div class='job-number'>Job# "+formData[0].job_no + "</div></td>";
	                     	html += "</tr>";
	                    html += "</table>";
	                html += "</div>";
	                html += "<div class='columns'>";
	                    html += "<div class='column is-12'>";
	                        html += "<table>";
	                            html += "<thead>";
	                                html += "<tr>";
	                                    html += "<th colspan='2'>Job Details</th>";
	                                html += "</tr>";
	                            html += "</thead>";
	                            html += "<tbody>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Job No.</td>";
	                                    html += "<td>"+ formData[0].job_no + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Date</td>";
	                                    html += "<td>"+ formData[0].service_date + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Time</td>";
	                                    html += "<td>"+ formData[0].service_time + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Target Language</td>";
	                                    html += "<td>"+ formData[0].language + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Description</td>";
	                                    html += "<td>"+ (formData[0].service_description == null ? '\u00A0' :  formData[0].service_description) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Client Name</td>";
	                                    html += "<td>"+ (formData[0].case_name_lep == null ? '\u00A0' :  formData[0].case_name_lep) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Case No./MRN</td>";
	                                    html += "<td>"+ (formData[0].case_num_mrn == null ? '\u00A0' :  formData[0].case_num_mrn) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Department/Room No.</td>";
	                                    html += "<td>"+ (formData[0].dept_num == null ? '\u00A0' :  formData[0].dept_num) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Location Address</td>";
	                                    html += "<td>"+ (formData[0].location_name == null ? '\u00A0' :  formData[0].location_name) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Facilitator's Name</td>";
	                                    html += "<td>"+ (formData[0].contact_name == null ? '\u00A0' :  formData[0].contact_name) + "</td>";
	                                html += "</tr>";

	                                $.each(vendorPayment, function(index, data){
	                                	if(data.rate !== 0){
			                                html += "<tr>";
			                                    html += "<td style='width: 200px;'>"+ data.rate_type_name +"</td>";
			                                    html += "<td>"+ data.details + "</td>";
			                                html += "</tr>";
			                            }
	                                });

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Cancellation Policy</td>";
	                                    html += "<td>"+ (formData[0].cancellation_policy == null ? '\u00A0' :  formData[0].cancellation_policy) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Special Instructions</td>";
	                                    html += "<td>"+ (formData[0].special_instructions == null ? '\u00A0' :  formData[0].special_instructions) + "</td>";
	                                html += "</tr>";

	                            html += "</tbody>";
	                        html += "</table>";
	                    html += "</div>";
	                html += "</div>";


				html += "</div>";
			html += "</div>";
		html += "</div>";
    	html += "<br/>";

		html += "<style>";
			html += ".print-request{overflow-y: hidden;overflow-x: hidden;zoom: 80%; font-size: 12px !important;}.print-request .column{padding: 0;}.print-request table{table-layout: auto !important; }.print-request{max-width: 75rem;margin-right: auto;margin-left: auto;}.print-request {padding-right: 2rem;padding-left: 2rem}.print-request .print-request {margin-top: 20px;}.print-request #app {margin: 2.25rem auto;}.print-request h1 {color: #006FC0;font-size: 1.5rem;font-weight: 600; }.print-request table {border-spacing: 0;width: 100%;margin-top: 5px !important;; }.print-request table th {font-weight: 700;color: #006FC0;padding: 5px;background-color: #DBE6F0;font-size: 1.125rem;border: 1px solid #c1c1c1;border-bottom: none; text-align: center !important;}.print-request table tr td {font-size: 0.875rem;padding: 2px;border-left: 1px solid #c1c1c1; border-top: 1px solid #c1c1c1;}.print-request table tr td:first-child {font-weight: bold; }.print-request table tr td:nth-last-child(2) {border-right: 1px solid #c1c1c1;}.print-request table tr:last-child td{border-bottom: 1px solid #c1c1c1;}.print-request .job-number {font-size: 1.25rem;text-align: right;margin-top: 0.25rem; }.print-request .internal-use {background-color: #E6B7B8;color: #632324;}.print-request table.heading tr td{padding: 0 !important; border: none !important;}";
			html += "";
			html += "";

    	html += "</style>";



    	var url = rootState.auth.l+'v1/pdf/htmlToPDF/';
    	var filename = jobNo+'-'+rootState.global.timestamp;
		var saveData = {
			'filename': filename,
			'body': html
		};

		$.ajax({
			url: url,
			data: saveData,
			xhrFields: {
				responseType: 'blob'
			},
			type: 'POST',
			beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a);},
         	success: function(data) {

         		var a = document.createElement('a');
				document.body.appendChild(a); //Firefox requires this
	            var url = window.URL.createObjectURL(data);
	            a.href = url;
	            a.download = filename + '.pdf';
	            a.click();

	            //Add timeout just in case the link hasn't been clicked yet before removing it from the DOM
	            setTimeout(function(){
	            	document.body.removeChild(a);
	            	window.URL.revokeObjectURL(url);
	            }, 300);

         	},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, {root: true})
			}
        });
	},

	// Translation Export to PDF
	saveAsTranslationPDF({commit, dispatch, rootState, state}, apptId){
		dispatch('global/getTimestamp', {}, {root: true});
		var formData = rootState.requests.formData;
		var vendorPayment = rootState.requests.vendorPayment;
		var user = rootState.auth.user;
		var clientRequestId = formData[0].id;
		var jobNo = formData[0].job_no;
		var html = "";
		var statusClass = sessionStorage.getItem("statusClass");
		var showNotes = sessionStorage.getItem("showNotes");
		// var remarks = JSON.parse(sessionStorage.getItem("REMARKS-DATA"));
		// var cancelNotes = remarks.remarks_notes;

		var showNotesClass = '';
		var status = formData[0].status;

		//Create the Client Request content
    	html += "<div class='print-request'>";
    		html += "<div class='columns'>";
    			html += "<div class='column is-12'>";
	                html += "<div class='columns'>";
	                    html += "<table class='heading'>";
	                     	html += "<tr>";
		                        html += "<td><div class='job-number'>Job# "+formData[0].job_no + "</div></td>";
	                     	html += "</tr>";
	                    html += "</table>";
	                html += "</div>";
	                html += "<div class='columns'>";
	                    html += "<div class='column is-12'>";
	                        html += "<table>";
	                            html += "<thead>";
	                                html += "<tr>";
	                                    html += "<th colspan='2'>Job Details</th>";
	                                html += "</tr>";
	                            html += "</thead>";
	                            html += "<tbody>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Job No.</td>";
	                                    html += "<td>"+ formData[0].job_no + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Due Date</td>";
	                                    html += "<td>"+ formData[0].vendor_due_date + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Due Time</td>";
	                                    html += "<td>"+ formData[0].vendor_due_time + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Target Language</td>";
	                                    html += "<td>"+ formData[0].language + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Document Description</td>";
	                                    html += "<td>"+ (formData[0].doc_description == null ? '\u00A0' :  formData[0].doc_description) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'># of Documents</td>";
	                                    html += "<td>"+ (formData[0].num_of_document == null ? '\u00A0' :  formData[0].num_of_document) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Word Count</td>";
	                                    html += "<td>"+ (formData[0].word_count == null ? '\u00A0' :  formData[0].word_count) + "</td>";
	                                html += "</tr>";

	                                $.each(vendorPayment, function(index, data){
	                                	if(data.rate !== 0){
			                                html += "<tr>";
			                                    html += "<td style='width: 200px;'>"+ data.rate_type_name +"</td>";
			                                    html += "<td>"+ data.details + "</td>";
			                                html += "</tr>";
			                            }
	                                });

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Special Instructions</td>";
	                                    html += "<td>"+ (formData[0].special_instructions == null ? '\u00A0' :  formData[0].special_instructions) + "</td>";
	                                html += "</tr>";

	                            html += "</tbody>";
	                        html += "</table>";
	                    html += "</div>";
	                html += "</div>";


				html += "</div>";
			html += "</div>";
		html += "</div>";
    	html += "<br/>";

		html += "<style>";
			html += ".print-request{overflow-y: hidden;overflow-x: hidden;zoom: 80%; font-size: 12px !important;}.print-request .column{padding: 0;}.print-request table{table-layout: auto !important; }.print-request{max-width: 75rem;margin-right: auto;margin-left: auto;}.print-request {padding-right: 2rem;padding-left: 2rem}.print-request .print-request {margin-top: 20px;}.print-request #app {margin: 2.25rem auto;}.print-request h1 {color: #006FC0;font-size: 1.5rem;font-weight: 600; }.print-request table {border-spacing: 0;width: 100%;margin-top: 5px !important;; }.print-request table th {font-weight: 700;color: #006FC0;padding: 5px;background-color: #DBE6F0;font-size: 1.125rem;border: 1px solid #c1c1c1;border-bottom: none; text-align: center !important;}.print-request table tr td {font-size: 0.875rem;padding: 2px;border-left: 1px solid #c1c1c1; border-top: 1px solid #c1c1c1;}.print-request table tr td:first-child {font-weight: bold; }.print-request table tr td:nth-last-child(2) {border-right: 1px solid #c1c1c1;}.print-request table tr:last-child td{border-bottom: 1px solid #c1c1c1;}.print-request .job-number {font-size: 1.25rem;text-align: right;margin-top: 0.25rem; }.print-request .internal-use {background-color: #E6B7B8;color: #632324;}.print-request table.heading tr td{padding: 0 !important; border: none !important;}";
			html += "";
			html += "";

    	html += "</style>";



    	var url = rootState.auth.l+'v1/pdf/htmlToPDF/';
    	var filename = jobNo+'-'+rootState.global.timestamp;
		var saveData = {
			'filename': filename,
			'body': html
		};

		$.ajax({
			url: url,
			data: saveData,
			xhrFields: {
				responseType: 'blob'
			},
			type: 'POST',
			beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a);},
         	success: function(data) {

         		var a = document.createElement('a');
				document.body.appendChild(a); //Firefox requires this
	            var url = window.URL.createObjectURL(data);
	            a.href = url;
	            a.download = filename + '.pdf';
	            a.click();

	            //Add timeout just in case the link hasn't been clicked yet before removing it from the DOM
	            setTimeout(function(){
	            	document.body.removeChild(a);
	            	window.URL.revokeObjectURL(url);
	            }, 300);

         	},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, {root: true})
			}
        });
	},

	// Telephonic Export to PDF
	saveAsTelephonicPDF({commit, dispatch, rootState, state}, apptId){
		dispatch('global/getTimestamp', {}, {root: true});
		var formData = rootState.requests.formData;
		var vendorPayment = rootState.requests.vendorPayment;
		var user = rootState.auth.user;
		var clientRequestId = formData[0].id;
		var jobNo = formData[0].job_no;
		var html = "";
		var statusClass = sessionStorage.getItem("statusClass");
		var showNotes = sessionStorage.getItem("showNotes");
		// var remarks = JSON.parse(sessionStorage.getItem("REMARKS-DATA"));
		// var cancelNotes = remarks.remarks_notes;

		var showNotesClass = '';
		var status = formData[0].status;

		//Create the Client Request content
    	html += "<div class='print-request'>";
    		html += "<div class='columns'>";
    			html += "<div class='column is-12'>";
	                html += "<div class='columns'>";
	                    html += "<table class='heading'>";
	                     	html += "<tr>";
		                        html += "<td><div class='job-number'>Job# "+formData[0].job_no + "</div></td>";
	                     	html += "</tr>";
	                    html += "</table>";
	                html += "</div>";
	                html += "<div class='columns'>";
	                    html += "<div class='column is-12'>";
	                        html += "<table>";
	                            html += "<thead>";
	                                html += "<tr>";
	                                    html += "<th colspan='2'>Job Details</th>";
	                                html += "</tr>";
	                            html += "</thead>";
	                            html += "<tbody>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Job No.</td>";
	                                    html += "<td>"+ formData[0].job_no + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Date</td>";
	                                    html += "<td>"+ formData[0].service_date + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Time</td>";
	                                    html += "<td>"+ formData[0].service_time + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Target Language</td>";
	                                    html += "<td>"+ formData[0].language + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Service Description</td>";
	                                    html += "<td>"+ (formData[0].service_description == null ? '\u00A0' :  formData[0].service_description) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Client Name</td>";
	                                    html += "<td>"+ (formData[0].case_name_lep == null ? '\u00A0' :  formData[0].case_name_lep) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Case No./MRN</td>";
	                                    html += "<td>"+ (formData[0].case_num_mrn == null ? '\u00A0' :  formData[0].case_num_mrn) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Facilitator</td>";
	                                    html += "<td>"+ (formData[0].contact_name == null ? '\u00A0' :  formData[0].contact_name) + "</td>";
	                                html += "</tr>";

	                                $.each(vendorPayment, function(index, data){
	                                	if(data.rate !== 0){
			                                html += "<tr>";
			                                    html += "<td style='width: 200px;'>"+ data.rate_type_name +"</td>";
			                                    html += "<td>"+ data.details + "</td>";
			                                html += "</tr>";
			                            }
	                                });

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Cancellation Policy</td>";
	                                    html += "<td>"+ (formData[0].cancellation_policy == null ? '\u00A0' :  formData[0].cancellation_policy) + "</td>";
	                                html += "</tr>";

	                                html += "<tr>";
	                                    html += "<td style='width: 200px;'>Special Instructions</td>";
	                                    html += "<td>"+ (formData[0].special_instructions == null ? '\u00A0' :  formData[0].special_instructions) + "</td>";
	                                html += "</tr>";

	                            html += "</tbody>";
	                        html += "</table>";
	                    html += "</div>";
	                html += "</div>";


				html += "</div>";
			html += "</div>";
		html += "</div>";
    	html += "<br/>";

		html += "<style>";
			html += ".print-request{overflow-y: hidden;overflow-x: hidden;zoom: 80%; font-size: 12px !important;}.print-request .column{padding: 0;}.print-request table{table-layout: auto !important; }.print-request{max-width: 75rem;margin-right: auto;margin-left: auto;}.print-request {padding-right: 2rem;padding-left: 2rem}.print-request .print-request {margin-top: 20px;}.print-request #app {margin: 2.25rem auto;}.print-request h1 {color: #006FC0;font-size: 1.5rem;font-weight: 600; }.print-request table {border-spacing: 0;width: 100%;margin-top: 5px !important;; }.print-request table th {font-weight: 700;color: #006FC0;padding: 5px;background-color: #DBE6F0;font-size: 1.125rem;border: 1px solid #c1c1c1;border-bottom: none; text-align: center !important;}.print-request table tr td {font-size: 0.875rem;padding: 2px;border-left: 1px solid #c1c1c1; border-top: 1px solid #c1c1c1;}.print-request table tr td:first-child {font-weight: bold; }.print-request table tr td:nth-last-child(2) {border-right: 1px solid #c1c1c1;}.print-request table tr:last-child td{border-bottom: 1px solid #c1c1c1;}.print-request .job-number {font-size: 1.25rem;text-align: right;margin-top: 0.25rem; }.print-request .internal-use {background-color: #E6B7B8;color: #632324;}.print-request table.heading tr td{padding: 0 !important; border: none !important;}";
			html += "";
			html += "";

    	html += "</style>";



    	var url = rootState.auth.l+'v1/pdf/htmlToPDF/';
    	var filename = jobNo+'-'+rootState.global.timestamp;
		var saveData = {
			'filename': filename,
			'body': html
		};

		$.ajax({
			url: url,
			data: saveData,
			xhrFields: {
				responseType: 'blob'
			},
			type: 'POST',
			beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a);},
         	success: function(data) {

         		var a = document.createElement('a');
				document.body.appendChild(a); //Firefox requires this
	            var url = window.URL.createObjectURL(data);
	            a.href = url;
	            a.download = filename + '.pdf';
	            a.click();

	            //Add timeout just in case the link hasn't been clicked yet before removing it from the DOM
	            setTimeout(function(){
	            	document.body.removeChild(a);
	            	window.URL.revokeObjectURL(url);
	            }, 300);

         	},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, {root: true})
			}
        });
	},


}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}
